import type { DataProviders } from '@refinedev/core';

import {
  apiPanorama,
  apiPanoramaV2,
  dataProvider,
  withConfigValidationEnhancer,
  withCustomFieldEnhancer,
  withErrorNotificationEnhancer,
  withFilterEnhancer
} from '@/config';

import { compose } from './compose';

const getDataProviders = (): DataProviders => {
  const composedDefaultDataProvider = compose(
    withErrorNotificationEnhancer,
    withCustomFieldEnhancer,
    withFilterEnhancer,
    withConfigValidationEnhancer
  )(dataProvider(apiPanorama));

  const composedV2DataProvider = compose(
    withErrorNotificationEnhancer,
    withCustomFieldEnhancer,
    withFilterEnhancer,
    withConfigValidationEnhancer
  )(dataProvider(apiPanoramaV2));

  return {
    default: composedDefaultDataProvider,
    v2: composedV2DataProvider
  };
};

export default getDataProviders;
